import { api } from "@/features/utils/fetch-server";
import type { GeocodingResponse } from "../types";

export class MapsAPI {
  static async geocode(address: string): Promise<GeocodingResponse> {
    return api.post(`/api/utils/v1/geocode`, { address });
  }

  static async getFormattedAddress(
    address: string,
  ): Promise<{ formatted: string | null }> {
    return api.post(`/api/utils/v1/format-address`, { address });
  }
}
